import cf from './cf';
//import c10v from './c10v_20211024';
import c30v from './c30v_20211024';

export default class c30v3a extends c30v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = { // 団体本体
      class: 'c30v3a',
      name: '設定'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
